import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetListProfileResponse } from 'domain/models';

interface IUsersState {
  profilesAssociated: GetListProfileResponse[];
}

interface IPayloadProfiles extends PayloadAction<GetListProfileResponse[]> {}

const initialState: IUsersState = {
  profilesAssociated: [],
};

export const UsersAssociatedSlice = createSlice({
  name: 'usersAssociated',
  initialState,
  reducers: {
    loadProfilesAssociated: (state, action: IPayloadProfiles) => {
      state.profilesAssociated = action.payload;
    },
    clearProfilesAssociated: (state) => {
      state.profilesAssociated = [];
    },
  },
});

export const { loadProfilesAssociated, clearProfilesAssociated } = UsersAssociatedSlice.actions;

export default UsersAssociatedSlice.reducer;
